export { default as Pagination } from './pagination';
export { paginationType } from './pagination.types';
export { paginationStandard } from './__fixtures__/pagination';
